var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPotg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 40",
    filter: "url(#filter0_d_17993_98996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.45581 24.9999L12.7535 23.0428L16.7953 24.9999L16.1814 20.2617L19.2 16.9656L14.6977 16.3991L12.7535 12.3304L10.5535 16.3991L6 16.9656L9.22326 20.2617L8.45581 24.9999Z",
    fill: "url(#paint0_linear_17993_98996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8186 9.03426L12.7535 11.7639L18.586 9.03426V6.09863H6.8186V9.03426Z",
    fill: "url(#paint1_linear_17993_98996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45581 24.9999L12.7535 23.0428L16.7953 24.9999L16.1814 20.2617L19.2 16.9656L14.6977 16.3991L12.7535 12.3304L10.5535 16.3991L6 16.9656L9.22326 20.2617L8.45581 24.9999Z",
    stroke: "#865E20",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8186 9.03426L12.7535 11.7639L18.586 9.03426V6.09863H6.8186V9.03426Z",
    stroke: "#865E20",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 42",
    d: "M12.5814 16.4873L11.8596 17.6873L9.59082 18.1279",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 43",
    d: "M10.8739 7.62117L8.40037 7.57956",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17993_98996",
    x: 0.75,
    y: 0.848633,
    width: 23.7002,
    height: 29.4014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.635294 0 0 0 0 0.137255 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17993_98996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17993_98996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17993_98996",
    x1: 8.40625,
    y1: 1,
    x2: 21.2985,
    y2: 3.54117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAF1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17993_98996",
    x1: 8.40625,
    y1: 1,
    x2: 21.2985,
    y2: 3.54117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAF1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotg);
export default __webpack_public_path__ + "static/media/POTG.f392cf19bd1f2d3cb7aa48d37525ed45.svg";
export { ForwardRef as ReactComponent };